<template>
  <div>
    <sweet-modal
      ref="homeModal"
      class="modal-home"
      title="Choose starting project"
      @close="onClose"
    >
      <div class="cards-grid">
        <vs-card actionable class="cardx" fixed-height>
          <div slot="header" @click="setProjectTemplate('Atlas')">
            <h3>ATLAS</h3>
          </div>
          <div slot="media" @click="setProjectTemplate('Atlas')">
            <img class="thumbs" src="@/assets/images/atlas_thumb.jpg" />
          </div>
          <div @click="setProjectTemplate('Atlas')">
            <p>
              Viability ATLAS for the development of offshore aquaculture in the
              Spanish coasts.
            </p>
          </div>
          <div slot="extra-content" @click="setProjectTemplate('Atlas')">
            <vs-divider>Sponsors & Partners</vs-divider>
            <!-- <img width="340"
						src="@/assets/logos/MITECO+FB_Pleamar+FEMP_700.png">-->
            <div class="container-logos">
              <div class="container-logos">
                <img
                  class="logo-miteco"
                  src="@/assets/logos/MITECO_FB_45h.png"
                />
              </div>
              <img class="logo-pleamar" src="@/assets/logos/PLEAMAR_45h.png" />
              <img src="@/assets/logos/FEMP_45h.png" />
            </div>
            <br />
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                href="https://www.programapleamar.es/proyectos/atlas-de-viabilidad-para-el-desarrollo-de-la-acuicultura-oceanica-en-espana-atlas/"
                class="accent"
                type="filled"
                target
                line-position="top"
                >+ Info</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
        <vs-card actionable class="cardx" fixed-height>
          <div slot="header" @click="setProjectTemplate('Renaqua')">
            <h3>RENAQUA</h3>
          </div>
          <div slot="media" @click="setProjectTemplate('Renaqua')">
            <img class="thumbs" src="@/assets/images/renaqua_thumb.jpg" />
          </div>
          <div @click="setProjectTemplate('Renaqua')">
            <p>
              Co-location Opportunities for RENewable energies and AQUAculture
              facilities, decision support for operational Multi-Use Platform
              activities at coastal areas
            </p>
          </div>
          <div slot="extra-content" @click="setProjectTemplate('Renaqua')">
            <vs-divider>Sponsors & Partners</vs-divider>
            <img class="logo-renaqua" src="@/assets/logos/GlobalRenaqua.png" />
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                class="accent"
                target
                type="filled"
                href="http://renaqua.ihcantabria.com/"
                >+ Info</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
        <!-- <div class="logos-carousel">
          Opcion 2: Carrusel de logos que se mueva on hover
          <img class="logo-renaqua"
               src="./../assets/logos/GlobalRenaqua.png">
				</div>-->
      </div>
    </sweet-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { MENUS_INDEX } from "@/constants.js";

export default {
  props: {
    autoOpen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      toggle: "isHomeModalVisible"
    })
  },
  watch: {
    toggle() {
      if (this.toggle) {
        this.$refs.homeModal.open();
      }
    }
  },
  mounted() {
    if (this.autoOpen) {
      this.$refs.homeModal.open();
    }
  },
  methods: {
    ...mapActions({
      toggleHome: "toggleHome",
      setActiveMenus: "setActiveMenus"
    }),
    setProjectTemplate(projectName) {
      switch (projectName) {
        case "Atlas":
          this.setActiveMenus({
            top: MENUS_INDEX.SCALES.NATIONAL,
            mid: MENUS_INDEX.SECTORS.NATIONAL_AQUACULTURE,
            bottom: -1
          });
          break;
        case "Renaqua":
          this.setActiveMenus({
            top: MENUS_INDEX.SCALES.GLOBAL,
            mid: MENUS_INDEX.SECTORS.GLOBAL_AQUACULTURE,
            bottom: -1
          });
          break;
      }
      this.$refs.homeModal.close();
    },
    onClose() {
      this.toggleHome(false);
    }
  }
};
</script>
<style scoped>
.modal-home >>> .sweet-modal {
  max-width: 840px;
  max-height: 700px;
  height: 70%;
}

.sweet-modal-overlay {
  background: rgba(0, 0, 0, 0.1);
}
.cards-grid {
  display: grid;
  grid-gap: 1rem;
  max-height: 50vh;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}
.thumbs {
  max-height: 11rem;
}
p {
  text-align: left;
}
/* Logos */
.container-logos {
  padding: 5px;
  margin-bottom: 10px;
}

.logo-renaqua {
  max-height: 140px;
}

.logo-miteco {
  margin-right: 5px;
}

.logo-pleamar {
  margin-right: 15px;
}
</style>
